import React, { useEffect } from "react";
import { IP } from "../../internalServer";


function PdfViewer({ setMideaviewer, attachment }) {

    const getFileUrl = (a) => {
        let p = a.replace(/^\./, "");
        return IP + p;
    };
    const getAttachmentString = (file) => {
        if (!file) return "";

        if (typeof file === "string") return file;

        if (file.name) return file.name;
        if (file.file_path) return file.file_path;
        if (file.fileName) return file.fileName;
        if (file.filename) return file.filename;
        if (file.url) return file.url;

        return "";
    };
    const attachmentStr = getAttachmentString(attachment);

    const isPDF = attachmentStr.toLowerCase().endsWith(".pdf");
    const fileUrl = getFileUrl(attachmentStr)

    // 🔽 Auto-download if NOT PDF
    useEffect(() => {
        if (!isPDF && attachment) {
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = attachment?.split("/").pop();
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Close viewer after download
            setMideaviewer(false);
        }
    }, [isPDF, attachment, fileUrl, setMideaviewer]);

    return (
        <div className="midea_transprant_body" style={{ marginLeft: "0px" }}>
            <div className="midea_container shadow">
                <button
                    onClick={() => setMideaviewer(false)}
                    aria-label="Close"
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        border: "none",
                        background: "#111827",
                        color: "#fff",
                        fontSize: "22px",
                        cursor: "pointer",
                        zIndex: 10,
                    }}
                >
                    x
                </button>

                {/* ✅ Show iframe only for PDF */}
                {isPDF && (
                    <iframe
                        title="pdf-viewer"
                        src={`https://docs.google.com/gview?url=${encodeURIComponent(
                            fileUrl
                        )}&embedded=true`}
                        className="iframe"
                    />
                )}
            </div>
        </div>
    );
}

export default PdfViewer;
